import React, { Component, useState, useRef, useEffect } from "react";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const DropDown = ({
  name,
  list,
  engName,
  changeHandler,
  selected,
  stepOnboarding,
}) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [is_dropdown, setIsDropDown] = useState(false);
  const isMobile = useMediaQuery("(max-width: 768px)");
  const ref = useRef();

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (is_dropdown && ref.current && !ref.current.contains(e.target)) {
        setIsDropDown(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [is_dropdown]);

  const ReedsOrDensity =
    name === "شانه" ||
    name == "تراکم" ||
    name == "Reeds" ||
    name == "density" ||
    name == "Teppich Schilf" ||
    name == "كثافة" ||
    name == "القصب" ||
    name == "Dichte";

  return (
    <div
      ref={ref}
      style={{
        width: "100%",
        position: "relative",
        zIndex: stepOnboarding === 2 ? 1 : "auto",
      }}
    >
      <div
        style={{
          borderRadius: 50,
          height: 40,
          backgroundColor: "#f8f8f8",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 10px",
          border:
            selected.length > 0 && isMobile ? "1px solid #de2a35" : "none",
        }}
        onClick={() => setIsDropDown(!is_dropdown)}
      >
        <div className="d-flex justify-content-start m-0">
          {" "}
          {selected.length > 0 && (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                borderRadius: "50%",
                backgroundColor: "#de2a35",
                color: "#fff",
                width: isMobile ? 20 : 25,
                height: isMobile ? 20 : 25,
                fontFamily: "shabnam",
                margin: 0,
                fontSize: 12,
                position: isMobile ? "absolute" : "inherit",
                top: isMobile ? -5 : 0,
                right: isMobile ? -7 : 0,
              }}
            >
              {selected.length}
            </div>
          )}
          <span
            style={{
              margin: 0,
              marginRight: selected.length > 0 && !isMobile ? 10 : 0,
              color: selected.length > 0 ? "#de2a35" : "#000",
            }}
          >
            {name}
          </span>
        </div>
        <span
          style={{
            color: "gray",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            margin: 0,
          }}
        >
          <KeyboardArrowDownRoundedIcon />
        </span>
      </div>
      <ul
        style={{
          display: is_dropdown ? "block" : "none",
          position: "absolute",
          top: 40,
          right: 0,
          left: 0,
          backgroundColor: "#f8f8f8",
          cursor: "pointer",
          border: "0.5px solid #f1f1f1",
          borderRadius: 5,
          zIndex: 100,
          maxHeight: 200,
          overflowY: "scroll",
        }}
      >
        {list.map((item) => {
          return (
            <li
              style={{
                fontSize: 12,
                color: "gray",
                padding: isMobile ? 5 : 10,
                textAlign: "right",
              }}
              className="d-flex justify-content-start"
              onClick={() =>
                changeHandler(engName, ReedsOrDensity ? item : item.id)
              }
            >
              <input
                type="checkbox"
                style={{ margin: 0, margin: isMobile ? "0 4px" : "0 10px" }}
                checked={
                  selected?.indexOf(item.id) !== -1 ||
                  selected.indexOf(item) !== -1
                }
              />
              {ReedsOrDensity ? item : item.name}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default DropDown;
